import { render, staticRenderFns } from "./MailTemplates.vue?vue&type=template&id=5d1ab798"
import script from "./MailTemplates.vue?vue&type=script&lang=js"
export * from "./MailTemplates.vue?vue&type=script&lang=js"
import style0 from "./MailTemplates.vue?vue&type=style&index=0&id=5d1ab798&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d1ab798')) {
      api.createRecord('5d1ab798', component.options)
    } else {
      api.reload('5d1ab798', component.options)
    }
    module.hot.accept("./MailTemplates.vue?vue&type=template&id=5d1ab798", function () {
      api.rerender('5d1ab798', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PrintSuite/MailTemplates.vue"
export default component.exports